import kebabCase    from '../../../../../Lib/helpers/kebabCase';
import LineOutput   from './LineOutput';

export default class JsonLine extends LineOutput {

    output() {
        return `"${kebabCase(this.subject.name)}": "${this.decorator.output()}",`; //todo remove trailing comma on last line?
    }

}